import { Pipe, PipeTransform } from '@angular/core';
import { Manuscript } from '../models/manuscript';
import { DateStruct, DateRange, DateCalendar } from '../models/date-range';

@Pipe({
    name: 'getMsDate'
})
export class GetMsDatePipe implements PipeTransform {

    /* Make the manuscript date label from data */
    transform(
        manuscript: Manuscript,
        calendar: DateCalendar = DateCalendar.Islamic
        ): string {

        if (calendar === DateCalendar.All) {
            const dateLabel: Array<string> = [];
            const islamicDate = this.getMsDateLabel(manuscript.__date, DateCalendar.Islamic);
            const gregorianDate = this.getMsDateLabel(manuscript.__date, DateCalendar.Gregorian);
            if (islamicDate) {
                dateLabel.push(islamicDate);
            }
            if (gregorianDate) {
                dateLabel.push(gregorianDate);
            }

            if (dateLabel.length > 0) {
                return dateLabel.join(' / ');
            } else {
                return '';
            }
        } else {
            return this.getMsDateLabel(manuscript.__date, calendar);
        }
    }

    /* Get the manuscript date label based on input calendar */
    private getMsDateLabel(msDate: DateStruct, calendar: DateCalendar) {
        const dateLabel: Array<string> = [];

        if (msDate) {
            const msDateRange: DateRange = msDate[calendar];
            if (msDateRange.from) {
                dateLabel.push(msDateRange.from.toString());
            }
            if (msDateRange.to && (msDateRange.to !== msDateRange.from)) {
                dateLabel.push(msDateRange.to.toString());
            }
        }

        if (dateLabel.length > 0) {
            return dateLabel.join('-')
                + (calendar === DateCalendar.Islamic ? 'H' : '');
        } else {
            return '';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/get-ms-date.pipe.ts